import { PageHeader } from '../../shared/ui';

const assistantDescriptions = [
  {
    title: 'ИИ-Супервизор',
    description:
      'Анализирует расшифровку сессии и выдает профессиональные гипотезы: какие темы углубить, какие техники попробовать и где аккуратно скорректировать стратегию.',
  },
  {
    title: 'ИИ-Конспект',
    description:
      'Собирает структурный конспект встречи: фиксирует цели, ключевые инсайты, договоренности и атмосферу беседы, чтобы психолог мог быстро вернуться к контексту.',
  },
  {
    title: 'ИИ Домашнее задание',
    description:
      'Подбирает упражнения и шаги для клиента, объясняет как выполнять задания и зачем они нужны, помогая поддерживать динамику между сессиями.',
  },
  {
    title: 'ИИ Метафоры',
    description:
      'Генерирует образные истории, сравнения и метафоры, которые делают объяснения бережными и наглядными, а изменения — более ощутимыми для клиента.',
  },
  {
    title: 'ИИ коуч супервизор',
    description: 'Оценивает коучинговую сессию, напоминает про структуру, powerful questions и зоны роста для коуча.',
  },
  {
    title: 'ИИ Сказкотерапевт',
    description:
      'Создает индивидуальные терапевтические сказки и сюжеты для детской и семейной работы, переводя сложные переживания на понятный язык.',
  },
];

const AiAssistants = () => {
  return (
    <div className="pb-[80px]">
      <PageHeader backTo="/tools" title="ИИ Ассистенты ZiNGiZi" />
      <p className="text-ui text-ink-muted mb-5">
        ИИ Ассистенты помогают экономить время на рутины, расширяют поле гипотез и мягко сопровождают клиента между
        сессиями. Во время видеовстречи нажмите кнопку запуска ассистента и убедитесь, что клиент разрешил аудиозапись.
        После завершения сессии система автоматически сформирует тексты для всех активных ассистентов, а результаты
        будут доступны в терапевтическом журнале ZiNGiZi. Выберите ассистентов, которые нужны именно вам, и активируйте
        их в терапевтическом журнале.
      </p>

      <div className="grid gap-5 md:grid-cols-2">
        {assistantDescriptions.map((assistant) => (
          <div key={assistant.title} className="rounded-control bg-surface-muted p-5 shadow-raised">
            <p className="text-body-l-strong text-ink mb-2">{assistant.title}</p>
            <p className="text-ui text-ink-muted leading-relaxed">{assistant.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AiAssistants;
